import React, { Fragment } from "react";
import { SimilarAddresses } from "./helpers";
import { Form, Col } from "react-bootstrap";
import Cookie from "js-cookie";

const UPSAddress = ({
  handleValidate,
  errors,
  formValues,
  setFormValues,
  upsAddressValues,
  upsAddressFields,
  addressIndex,
  disableFields,
  onSelectAddress,
}) => {
  const upsAddressFieldChange = (e, addressType, fieldId, setFormValues) => {
    e.persist();
    setFormValues((state) => {
      const prevValue = [...state.upsAccountAddress];
      const initalValuesForAddress = prevValue[0].duns
        ? {}
        : {
            vendorProfileId: state.vendorProfileId,
            duns: state.duns,
            email: state.email,
            category: "UPS",
          };
      let upsAccountAddress = [...state.upsAccountAddress];
      upsAccountAddress.splice(addressIndex, 1, "");
      upsAccountAddress = upsAccountAddress.filter((item) => item !== "");
      upsAccountAddress.splice(addressIndex, 0, {
        ...prevValue[addressIndex],
        ...initalValuesForAddress,
        //SVH-2038 add to get current user email to set lastupdatedby field
        userEmail: Cookie.get("email").toLowerCase(),
        [fieldId]:
          fieldId === "suiteUnitFloor"
            ? e.target.value || null
            : fieldId === "state" ||
              fieldId === "country" ||
              fieldId === "zipCode" ||
              fieldId === "upsAccountNumber"
            ? e.target.value.toUpperCase()
            : e.target.value,
      });

      return {
        ...state,
        upsAccountAddress,
        valuesChanged:
          prevValue[addressIndex][fieldId] === e.target.value ? false : true,
      };
    });
  };

  const autoCompleteFieldChange = (e, props) => {
    upsAddressFieldChange(e, null, props.field.fieldId, props.setFormValues);
  };

  return upsAddressFields(addressIndex).map((addressField, index) => {
    return (
      <Fragment key={`upsAddressFragment${index}`}>
        {index === 0 && (
          <Form.Row key={`upsAddressContainer${index}`}>
            <Form.Group as={Col} md={4}>
              <Form.Label
                key={`upsAddressLabel${index}`}
                id="upsAddressTypeLabel"
                htmlFor={`upsAccountNumber_${index}`}
                style={{ color: "black", fontWeight: "500" }}
              >
                UPS Account #<span className="required">*</span>
              </Form.Label>
              <Form.Control
                key={`upsAccountNumber_${index}`}
                id="upsAccountNumber"
                name={`upsAccountNumber_ups${index}`}
                placeholder="FGR152"
                autoComplete="upsAccountNumber"
                type="text"
                disabled={disableFields}
                maxLength={6}
                onBlur={(e) =>
                  handleValidate(
                    {
                      field: {
                        fieldId: "upsAccountNumber",
                        key: `upsAccountNumber_ups${addressIndex}`,
                      },
                      fieldValue: e.target.value.toUpperCase() || "",
                    },
                    setFormValues
                  )
                }
                onChange={(e) => {
                  upsAddressFieldChange(
                    e,
                    null,
                    "upsAccountNumber",
                    setFormValues
                  );
                  handleValidate(
                    {
                      field: {
                        fieldId: "upsAccountNumber",
                        key: `upsAccountNumber_ups${addressIndex}`,
                      },
                      fieldValue: e.target.value.toUpperCase() || "",
                    },
                    setFormValues
                  );
                }}
                value={upsAddressValues["upsAccountNumber"] || ""}
              />
              {errors && errors[`upsAccountNumber_ups${addressIndex}`] && (
                <div style={{ color: "#d64a4a" }}>
                  {errors[`upsAccountNumber_ups${addressIndex}`]}
                </div>
              )}
            </Form.Group>
          </Form.Row>
        )}

        <Form.Row key={`upsddress${index}`}>
          <SimilarAddresses
            handleValidate={handleValidate}
            errors={errors}
            address={addressField}
            formValues={formValues}
            fieldValueObject={upsAddressValues}
            setFormValues={setFormValues}
            onChange={upsAddressFieldChange}
            onAutoCompleteChange={autoCompleteFieldChange}
            onSelectAddress={onSelectAddress}
            disableFields={disableFields}
            addressIndex={addressIndex}
          />
        </Form.Row>
      </Fragment>
    );
  });
};

export default UPSAddress;
